const value = {
    project: 'Проект',
    myProjects: 'Мои проекты',
    addProject: 'Добавить проект',
    system: 'Система',
    projectIsEmpty: 'Проект пуст',
    noResults: 'По вашим критериям поиска ничего не найдено',
    noProjects: 'Нет проектов',
    youAreNotAparticipantInTheProjects: 'Вы не являетесь участником проектов',
    noTeamForProject: 'У проекта нет команды',
    loadMore: 'Загрузить еще',
    team: 'Команда',
    teamDescription:
      'Пригласите участников по ссылке. Зарегистрированные пользователи смогут вступить в проект и выбрать роль из списка.',
    invitationLink: 'Ссылка-приглашение',
    invitationLinkHelperText: 'Выберите роли, которые пользователи смогут получить по новой ссылке',
    fullName: 'ФИО',
    projectRole: 'Роль',
    projectRoleDescription:
      'После сохранения на странице проекта появится ссылка-приглашение. По ней любой зарегистрированный пользователь сможет вступить в проект и выбрать роль',
    empty: '',
    addSystem: 'Добавить систему',
    editProject: 'Редактировать проект',
    noEstablishedSystems: 'В ваших проектах еще нет созданных АС',
    requirements: 'Требований',
    moveSystem: 'Перенести систему',
    copySystem: 'Копировать систему',
    training: 'Обучение',
    trainingPreview: 'Предпросмотр обучения',
    profile: 'Анкета',
    requirementsPreview: 'Предпросмотр требований',
    changeHistory: 'История изменений',
    downloadAsProfile: 'Выгрузить анкету АС',
    typeOfExecutors: 'Тип исполнителей',
    typeOfExecutorsHelperText:
      'В зависимости от выбранного значения в сформированном наборе требований будет скрыта часть дополнительных колонок, полей или требований. Например, для внешних разработчиков',
    noCharacteristics: 'Нет характеристик',
    totalProjects: 'проектов',
    totalSystems: 'систем',
    requirementsCollection: 'Коллекции требований',
    deleteProject: 'Удалить проект',
    deleteProjectMessage: 'Вы уверены, что хотите удалить проект',
    userProjectTable: {
      systems: 'Систем',
      requirements: 'Требований',
      lastActivity: 'Последняя активность',
      actions: 'Действия',
      project: 'Проект',
      risks: 'Риски',
    },
    youLeftProject: 'Вы покинули проект',
    leaveProject: 'Покинуть проект',
    returnToProject: 'Вернуться',
    selectRole: 'Выберите роль',
  };

export default value;
